/**
 * Action creators
 */
const actions = {
  setMaterialList: (data) => ({ type: 'SET_MATERIAL_LIST', data })
};

const wgw = (value) => (dispatch) => dispatch(
  actions.setMaterialList(value)
);

export default wgw;
